import { ID } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import cardFieldsDefault from "src/modules/pe-landing-module/data/utils/cardFieldsDefault"
import { SingleTab } from "src/modules/pe-landing-module/widgets/composite/SingleItem"
import FieldChanger from "../FieldChanger"
import { __ } from "src/libs/utilities"
import { Callout } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface ISingleCardFieldPanelContentProps {
   
}
const SingleCardFieldPanelContent = (props: ISingleCardFieldPanelContentProps): JSX.Element => {
    const { selectedCardField }	= useLandingStore((state: ILandingStore) => state) 
    if(!selectedCardField) {
        return <div className="container  mx-2 width-auto">            
            <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                <div className="small col-12">
                    {__("No cards selected")}
                </div>
                <div className="micro mt-2 col-12">
                    {__("Select some meat with cards")}
                </div>
            </Callout>
        </div>
    }
    const schema = cardFieldsDefault()[selectedCardField.type]?.schema
    const _schema: any = { 
        ...( schema.apollo_fields || {} ),
    }
    const onChange = (value: any, field: string, dop: any) => {
        console.log( value, field, dop ) 
    }
    const onCh = ( id: ID, value: any ) => { 
        console.log( id, value ) 
    }
    return <div className='mx-2 mb-4'>
        {
            Object.keys( _schema )
                .filter((key: string) => _schema[ key ].tab === "main" )
                .map((key: string) => {
                    return <div key={key} className="pl-5 bg-plain text-contrast my-1 mx-1">
                        <FieldChanger
                            value={ null }
                            editable
                            { ..._schema[ key ] }
                            onChange={ onChange }
                        />
                    </div>
                })
        }
        {
            schema.tabs.filter((tab: any) => tab._id !== "main")
            .map(( tab: any ) => {
                return <SingleTab
                    key={ tab._id }
                    tab={ tab } 
                    schema={ schema } 
                    onChange={ onCh } 
                    value={ null } 
                    className={ "pl-5 bg-plain text-contrast my-1 mx-1" } 
                    contClassName="w-100"
                    btnClassName="btn btn-sm btn-dark bg-contrast text-plain rounded-pill py-0 small mb-1 ml-1"
                />
            })
            
        }
    </div>
}
export default SingleCardFieldPanelContent